import React from 'react';
import { Icon } from './Icon.js';
export const IconBookOpen2Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M8.25,3.765L3.216,2.376h0c-.531-.147-1.087-.039-1.525,.295-.438,.334-.69,.841-.69,1.392V12.488c0,.785,.528,1.479,1.285,1.688l5.965,1.646V3.765Z", fill: "currentColor" }),
        React.createElement("path", { d: "M16.31,2.671c-.438-.333-.995-.442-1.526-.295l-5.034,1.389V15.821l5.966-1.646c.756-.209,1.284-.903,1.284-1.688V4.063c0-.551-.251-1.058-.69-1.392Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconBookOpen2Fill18.js.map